package org.ssoft.common.type

import kotlin.math.abs

@Suppress("ClassName")
sealed class ScreenRatio(
    override var mask: Int,
    val pair: Pair<Int, Int>,
    val label: String = "${pair.first} : ${pair.second}",
    val pairAlter: Pair<Int, Int> = pair,
) : Mask {
    data object NONE : ScreenRatio(0, -1 to -1, "NONE")

    data object _1_1 : ScreenRatio(256, 1 to 1, pairAlter = 1 to 1)

    data object _2_1 : ScreenRatio(2, 2 to 1)
    data object _3_2 : ScreenRatio(4, 3 to 2)
    data object _4_3 : ScreenRatio(8, 4 to 3)
    data object _5_4 : ScreenRatio(16, 5 to 4)
    data object _16_9 : ScreenRatio(32, 16 to 9)
    data object _16_10 : ScreenRatio(64, 16 to 10, pairAlter = 8 to 5)
    data object _21_9 : ScreenRatio(128, 21 to 9, pairAlter = 7 to 3)

    data object _1_2 : ScreenRatio(-2, 1 to 2)
    data object _2_3 : ScreenRatio(-4, 2 to 3)
    data object _3_4 : ScreenRatio(-8, 3 to 4)
    data object _4_5 : ScreenRatio(-16, 4 to 5)
    data object _9_16 : ScreenRatio(-32, 9 to 16)
    data object _10_16 : ScreenRatio(-64, 10 to 16, pairAlter = 5 to 8)
    data object _9_21 : ScreenRatio(-128, 9 to 21, pairAlter = 3 to 7)


//    infix fun match(mask: Int): Boolean = (this.mask and abs(mask)) > 0

    val land get() = mask > 0
    val port get() = mask < 0

    fun toAspectRatio() = AspectRatio[abs(mask)].first()

    override operator fun equals(other: Any?): Boolean {
        return other is ScreenRatio && other.mask == mask
    }

    override fun hashCode(): Int {
        return mask
    }

    fun reverse(): ScreenRatio = if (this == _1_1) this else ScreenRatio[mask * -1]

    companion object {

        val horizontal by lazy {
            listOf(_1_1, _2_1, _3_2, _4_3, _5_4, _16_9, _16_10, _21_9)
        }

        val vertical by lazy {
            listOf(_1_1, _1_2, _2_3, _3_4, _4_5, _9_16, _10_16, _9_21)
        }

        val all by lazy {
            (horizontal + (vertical - _1_1))
        }

        operator fun get(mask: Int): ScreenRatio {
            return when {
                mask == _1_1.mask -> _1_1
                mask > 0 -> Mask[mask, horizontal] ?: NONE
                else -> Mask[mask, vertical] ?: NONE
            }
        }

        operator fun get(pair: Pair<Int, Int>): ScreenRatio {
            return horizontal.firstOrNull {
                it.pair == pair || it.pairAlter == pair
            } ?: vertical.firstOrNull {
                it.pair == pair || it.pairAlter == pair
            } ?: NONE
        }

        operator fun get(aspectRation: AspectRatio, isHorizontal: Boolean): ScreenRatio {
            return when {
                aspectRation == AspectRatio._1_1 -> _1_1
                isHorizontal -> ScreenRatio[aspectRation.mask].takeIf { it != NONE } ?: _16_9
                else -> ScreenRatio[aspectRation.mask * (-1)].takeIf { it != NONE } ?: _9_16
            }
        }
    }
}